import React from "react";
import { MdErrorOutline } from "@react-icons/all-files/md/MdErrorOutline";
import { use404Translations } from "../../i18n/hooks/use404Translations";
import {
  NotFoundContainer,
  NotFoundContent,
  NotFoundIcon,
  NotFoundTitle,
  NotFoundSubtitle,
  NotFoundDescription,
  NotFoundButton,
} from "./styled";

const NotFoundPage: React.FC = () => {
  const { translations } = use404Translations();

  const handleGoToLapieza = () => {
    window.open("https://lapieza.io", "_blank");
  };

  return (
    <NotFoundContainer>
      <NotFoundContent>
        <NotFoundIcon>
          <MdErrorOutline size={64} />
        </NotFoundIcon>
        <NotFoundTitle>{translations.title}</NotFoundTitle>
        <NotFoundSubtitle>{translations.subtitle}</NotFoundSubtitle>
        <NotFoundDescription>
          {translations.description}
        </NotFoundDescription>
        <NotFoundButton onClick={handleGoToLapieza}>
          {translations.button}
        </NotFoundButton>
      </NotFoundContent>
    </NotFoundContainer>
  );
};

export default NotFoundPage;
